
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import en from "../locales/en";
import am from "../locales/am";

// Initialize i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    am: {
      translation: am,
    },
  },
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});



export default i18n;